var _defs, _path, _line, _path2, _path3, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIspIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#51b2cd;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H22V22H0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 0.009,
    transform: "translate(16.5 5.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.667,12.089,14.458,7.505a3.667,3.667,0,1,1,6.417,0l-3.208,4.583",
    transform: "translate(-1.167 -0.172)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.875,4.688,8.5,4,3,6.75V18.667l5.5-2.75,5.5,2.75,5.5-2.75V14.083",
    transform: "translate(-0.25 -0.334)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 12,
    transform: "translate(8 4)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 4,
    transform: "translate(14 14)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIspIcon);
export default __webpack_public_path__ + "static/media/ispIcon.f765d1c4079fb99d0fcbb205b01c5880.svg";
export { ForwardRef as ReactComponent };